import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/useAuth';
import { BrandMark } from '../components/BrandMark';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!email || !password || submitting) return;
    setSubmitting(true);
    setError('');
    const message = await signIn(email.trim(), password);
    if (message) setError(message === 'Invalid login credentials' ? '邮箱或密码不正确。' : message);
    setSubmitting(false);
  }

  return (
    <main className="login-page">
      <section className="login-intro">
        <BrandMark />
        <p className="eyebrow">AI INBOX</p>
        <h1>先记下来，别让念头逃走。</h1>
        <p>这里不要求标题和分类。你只负责说出来，系统负责安全保存和稍后整理。</p>
      </section>
      <form className="login-form" onSubmit={submit}>
        <div>
          <p className="section-kicker">私人入口</p>
          <h2>登录念头收件箱</h2>
          <p className="quiet">系统不开放注册，只允许已创建的账号。</p>
        </div>
        <label>
          邮箱
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <label>
          密码
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            minLength={6}
            required
          />
        </label>
        {error ? <p className="form-error">{error}</p> : null}
        <button className="primary-button" disabled={submitting}>
          {submitting ? '正在登录…' : '进入收件箱'}
        </button>
      </form>
    </main>
  );
}
